<script>
export default {
  name: "SimpleText",
};
</script>